import { useModuleBEM, usePackagesStyles } from "@b2bportal/core-themes";
import {
  CorePackagesComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { PackageSearch } from "@tenant/packages";
import { Page } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./PackageSearchPage.module.scss";

export type PackageSearchPageProps = PlatformComponentProps;

const COMPONENT_KEY = CorePackagesComponent.PackageSearchPage;

export const PackagesSearchPage = ({
  className,
  children,
}: PackageSearchPageProps) => {
  const styles = usePackagesStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <Page className={clsx(block, className)}>
      <div className={cn("container")}>
        <PackageSearch />
        {children}
      </div>
    </Page>
  );
};
